import React from 'react';
import { useTranslation } from 'react-i18next';

// components
import ChatBubble from 'eCoach/ChatBubble';
import ClickableInput from 'eCoach/ClickableInput';

// data
import helperPrompts from 'eCoach/promptHelper/prompts';

// styles
import * as StyledPromptControls from 'eCoach/_styles/PromptControls.style';

interface QuestionThemeProps {
  handleSelectedTheme: (theme: string) => void;
  selectedTheme: string | null;
}

export default function QuestionTheme({
  handleSelectedTheme,
  selectedTheme,
}: QuestionThemeProps): JSX.Element {
  const { t } = useTranslation('pageEcoach');

  const getThemes = () =>
    Object.keys(helperPrompts).map((theme) => (
      <ClickableInput
        inputAction={() => handleSelectedTheme(theme)}
        inputText={t(`promptHelper.${theme}`)}
        inputType="light"
        key={t(`promptHelper.${theme}`) as any}
      />
    ));

  const eCoachMessage = () => (
    <ChatBubble
      simpleString={t(
        "promptHelper.Let's start with a general theme. What would you like advice on?"
      )}
    />
  );

  if (selectedTheme)
    return (
      <>
        {eCoachMessage()}
        <ChatBubble
          simpleString={t(`promptHelper.${selectedTheme}`)}
          sentByUser
        />
      </>
    );

  return (
    <>
      {eCoachMessage()}
      <ChatBubble sentByUser>
        <StyledPromptControls.ButtonsColumn>
          {getThemes()}
          <ClickableInput
            inputAction={() => handleSelectedTheme('Something else')}
            inputText={t(`promptHelper.Something else`)}
            inputType="light"
            key="other"
          />
        </StyledPromptControls.ButtonsColumn>
      </ChatBubble>
    </>
  );
}
